import { D, formatMoney } from "@netkeep/fee-engine";
import type { FeeRule } from "@netkeep/fee-types";

const BASIS: Record<string, string> = { ITEM_PRICE: "item", BUYER_SHIPPING: "shipping", SALES_TAX: "tax" };

/** One-line, human-readable summary of a fee rule, e.g. "13.6% up to $7,500.00, then 2.35% + $0.30–$0.40". */
export function describeRule(rule: FeeRule, currency: string): string {
  const parts: string[] = [];
  if (rule.percentTiers) {
    parts.push(
      rule.percentTiers
        .map((t, i) =>
          t.upTo == null
            ? `${i === 0 ? "" : "then "}${t.percent}%`
            : `${t.percent}% up to ${formatMoney(new D(t.upTo), currency)}`,
        )
        .join(", "),
    );
  } else if (rule.percent) {
    parts.push(`${rule.percent}%`);
  }
  if (rule.fixedTiers) {
    const amounts = rule.fixedTiers.map((t) => new D(t.amount));
    const min = D.min(...amounts);
    const max = D.max(...amounts);
    parts.push(min.equals(max) ? formatMoney(min, currency) : `${formatMoney(min, currency)}–${formatMoney(max, currency)}`);
  } else if (rule.fixedAmount && !new D(rule.fixedAmount).isZero()) {
    parts.push(formatMoney(new D(rule.fixedAmount), currency));
  }
  let text = parts.join(" + ") || "No charge";
  if (rule.minimumFee) text += ` (min ${formatMoney(new D(rule.minimumFee), currency)})`;
  if (rule.maximumFee) text += ` (max ${formatMoney(new D(rule.maximumFee), currency)})`;
  return `${text} on ${rule.basis.map((b) => BASIS[b] ?? b).join(" + ")}`;
}
